export default "__VITE_ASSET__7c4f6e51__"